import React from 'react';
import "./About.css";

const About = () => {
    return (
        <div className='about'>
            <div className='aboutDetails'>
            <h6>WE ARE FOOTBALL MANIA</h6>
            <hr />
            <h3>Football Mania is the world’s leading football media company, built for the next generation of fans.</h3>
            <br />
            <p>Our mission is to give fans more of the game by building football communities that entertain, inform, and inspire action. We cover what you need to know and what you didn’t know is coming next. Our content spans football news & analysis, original reporting, social media, web stores, video, podcasts, newsletters, and live scores. By doing nothing but football, we offer fans everything in football.</p>
            </div>
        </div>
    );
};

export default About;